import { Component, EventEmitter, Input, Output } from '@angular/core';
import { TournamentService } from '../../../../services/tournament.service';

@Component({
  selector: 'group-ko-overview',
  templateUrl: 'group-ko-overview.html',
})
export class GroupKoOverviewPage {
  gamePlanList: IGamePlan[] = [];
  
  @Input() plan: any;
  @Input() header: boolean = true;

  @Output() onEdit = new EventEmitter<any>();

  constructor(public gs: TournamentService){}

  onOpenEdit(i: number, j: number){
    this.onEdit.emit({ i: i, j: j});
  }

  onRemoveTeam(){

  }

  sort(){
    if(!this.plan) return [];

    return this.plan.teams.sort((a, b) => b.points - a.points);
  }

  getGroupName(i: number){
    let ASCII = 65;
    return String.fromCharCode(ASCII + i);
  }
}

export interface IGamePlan {
  id: number;
  gameDay: number;
  name: string;
  team1: {
    id: number;
    name: string;
  };
  team2: {
    id: number;
    name: string;
  }
}






// WEBPACK FOOTER //
// /src/pages/apps/gamer/pages/results/result-group-ko/overview/group-ko-overview.ts